import { render, staticRenderFns } from "./ModalAviso.vue?vue&type=template&id=0ce1c3c0"
import script from "./ModalAviso.vue?vue&type=script&lang=js"
export * from "./ModalAviso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports